import { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import DashboardLayout from "../common/DashboardApp";
import {
  getJobPostData,
  deleteJobPost,
  changeJobPostStatus,
} from "../../../service/employerapi";
import { toast } from "react-toastify";
import Swal from "sweetalert2";

const JobList = () => {
  const [loading, setLoading] = useState(false);
  const location = useLocation();
  const [jobposts, setJobPost] = useState([]);

  useEffect(() => {
    if (location.state?.toastMessage) {
      toast.success(location.state.toastMessage);
    }

    const fetchJobPost = async () => {
      try {
        setLoading(true);
        const response = await getJobPostData();
        console.log(response);
        setJobPost(response.data || []);
      } catch (err) {
        console.error("Error fetching Job Post:", err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchJobPost();
  }, []);

  // Helper to get status badge
  const renderStatus = (status) => {
    if (status === "active") {
      return (
        <span
          style={{
            backgroundColor: "#00e721",
            padding: "2px 12px",
            borderRadius: "15px",
            color: "#ffffff",
          }}
        >
          Active
        </span>
      );
    } else if (status === "inactive") {
      return (
        <span
          style={{
            backgroundColor: "#e71b00",
            padding: "2px 12px",
            borderRadius: "15px",
            color: "#ffffff",
          }}
        >
          Inactive
        </span>
      );
    } else {
      return (
        <span
          style={{
            backgroundColor: "#e7b100",
            padding: "2px 12px",
            borderRadius: "15px",
            color: "#ffffff",
          }}
        >
          Expired
        </span>
      );
    }
  };

  const navigate = useNavigate();
  const handleEdit = (id) => {
    navigate(`/employer/edit-job/${id}`);
  };

  const handleDelete = async (id) => {
    try {
      const res = await deleteJobPost(id);
      toast.success(res.message || "Job deleted successfully!");
      setJobPost((prev) => prev.filter((job) => job._id !== id));
    } catch (err) {
      toast.error(err.message || "Failed to delete job.");
    }
  };

  const handleStatus = async (id, currentStatus) => {
    try {
      const newStatus = currentStatus === "active" ? "inactive" : "active";
      const res = await changeJobPostStatus({ id, status: newStatus });
      toast.success(res.data.message || "Status changed successfully!");

      setJobPost((prev) =>
        prev.map((job) =>
          job._id === id ? { ...job, status: newStatus } : job
        )
      );
    } catch (err) {
      toast.error(
        err.response?.data?.message || err.message || "Failed to change status."
      );
    }
  };

  return (
    <DashboardLayout>
      <div className="panelMainWrapper">
        <div className="panelCard">
          <div className="titlSectionu userpaneltitle text-left position-relative mb-5">
            <h2>Job List</h2>
            <a href="/employer/post-job" className="normalbtn editaccountbtn">
              <i className="fa-solid fa-plus"></i> Add Job
            </a>
          </div>

          <div className="jobListWrapper innerveiw">
            <div className="listWrap">
              <div className="row">
                {loading ? (
                  <div className="text-center w-100 my-5">
                    <div className="spinner-border text-primary" role="status">
                      <span className="visually-hidden">Loading...</span>
                    </div>
                  </div>
                ) : jobposts.length === 0 ? (
                  <div className="col-12">
                    <div className="alert alert-info text-center">
                      No jobs found.
                    </div>
                  </div>
                ) : (
                  jobposts.map((job) => (
                    <div key={job._id} className="col-md-4 mb-2">
                      <div className="astrocard position-relative">
                        <div
                          className="dropdown"
                          style={{
                            position: "absolute",
                            top: "10px",
                            right: "10px",
                          }}
                        >
                          <button
                            className="btn btn-light btn-sm"
                            type="button"
                            id={`dropdownMenuButton-${job._id}`}
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                            style={{
                              border: "none",
                              background: "transparent",
                              fontSize: "20px",
                              color: "#666",
                            }}
                          >
                            <i className="fa-solid fa-ellipsis-vertical"></i>
                          </button>
                          <ul
                            className="dropdown-menu dropdown-menu-end"
                            aria-labelledby={`dropdownMenuButton-${job._id}`}
                          >
                            <li>
                              <button
                                className="dropdown-item"
                                onClick={() => handleEdit(job._id)}
                              >
                                <i className="fa-solid fa-pen me-2 text-primary"></i>{" "}
                                Edit
                              </button>
                            </li>
                            <li>
                              <button
                                className="dropdown-item"
                                onClick={() => {
                                  Swal.fire({
                                    title: "Are you sure?",
                                    text: "You won't be able to revert this!",
                                    icon: "warning",
                                    showCancelButton: true,
                                    confirmButtonColor: "#d33",
                                    cancelButtonColor: "#3085d6",
                                    confirmButtonText: "Yes, delete it!",
                                    cancelButtonText: "Cancel",
                                  }).then((result) => {
                                    if (result.isConfirmed) {
                                      handleDelete(job._id);
                                    }
                                  });
                                }}
                              >
                                <i className="fa-solid fa-trash me-2 text-danger"></i>{" "}
                                Delete
                              </button>
                            </li>
                            <li>
                              <button
                                className="dropdown-item"
                                onClick={() =>
                                  handleStatus(job._id, job.status)
                                }
                              >
                                <i className="fa-solid fa-rotate me-2 text-warning"></i>{" "}
                                {job.status === "active"
                                  ? "Deactivate"
                                  : "Activate"}
                              </button>
                            </li>
                          </ul>
                        </div>
                        <div className="astrocContainer">
                          <div className="astroDetails">
                            <div className="astroName">
                              <div className="mb-3">
                                <a href={`/job-details/${job._id}`}>
                                  <h4>
                                    {job.jobTitle || ""}
                                  </h4>
                                </a>
                                {renderStatus(job.status)}
                              </div>

                              <div className="astroinfo">
                                <li>
                                  <img
                                    src={`${process.env.PUBLIC_URL}/assets/img/icons/location-.svg`}
                                    alt="icon"
                                  />
                                  <span>
                                    {job.city || ""}, {job.state || ""}
                                  </span>
                                </li>
                              </div>

                              <div className="astroinfo">
                                <li>
                                  <img
                                    src={`${process.env.PUBLIC_URL}/assets/img/icons/time.svg`}
                                    alt="img"
                                    style={{ width: "16px" }}
                                  />{" "}
                                  <span>
                                  ₹{job.minSalary || ""} - {job.maxSalary || ""}{" "}
                                  ({job.salaryType || ""})
                                  </span>
                                </li>
                              </div>

                              <div className="astroinfo">
                                <li>
                                  <img
                                    src={`${process.env.PUBLIC_URL}/assets/img/icons/newicon/jobtype.png`}
                                    alt="icon"
                                  />
                                  <span>{job.jobType || ""}</span>
                                </li>
                              </div>

                              <div className="astroinfo">
                                <li>
                                  <img
                                    src={`${process.env.PUBLIC_URL}/assets/img/icons/newicon/experience.png`}
                                    alt="icon"
                                  />
                                  <span>{job.experience || ""}</span>
                                </li>
                              </div>

                              <div className="astroinfo mt-5">
                                <li className="astroinfo mb-2">
                                  <span><strong>Posted : </strong>{job.jobPosted || ""}</span>
                                </li>
                                <li>
                                  <span>
                                  Admin Approval : 
                                  </span>
                                  <span
                                    className={
                                      job.adminAprrovalJobs === "Approved"
                                        ? "bg-success text-white px-2 py-1 rounded"
                                        : job.adminAprrovalJobs === "Rejected"
                                        ? "bg-danger text-white px-2 py-1 rounded"
                                        : "bg-warning text-dark px-2 py-1 rounded"
                                    }
                                  >
                                    {job.adminAprrovalJobs}
                                  </span>
                                </li>
                              </div>

                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </DashboardLayout>
  );
};

export default JobList;
